import React from 'react';
import { Col, Form, Input, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import Radio from 'components/radio';
import Helpers from 'helpers';
import { renderGroupedShopOptions } from 'components/shopOptions';

const InfoSection = ({ shops, inactiveShops }) => {
  const { t } = useTranslation();

  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Informazioni Generali')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Insegna')} name='company_id'>
          <Select
            {...Helpers.addSearchProps()}
            placeholder={t('Selezioni opzione')}
          >
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {renderGroupedShopOptions({
              shops,
              inactiveShops,
              t,
            })}
          </Select>
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Ruolo')} name='role'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item label={t('Nome')} name='name'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Cognome')} name='surname'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item label={t('Cellulare')} name='phone'>
          <Input addonBefore={'+39'} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Priorità di contatto')} name='priority'>
          <Radio.Group>
            <Radio value={1}>1</Radio>
            <Radio value={2}>2</Radio>
            <Radio value={3}>3</Radio>
            <Radio value={4}>4</Radio>
            <Radio value={5}>5</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
